// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".undershirts-size-modal[data-v-7b72636b] .FR-button{display:none}.undershirts-size-modal[data-v-7b72636b] .size-chart-menu-button-active{--bg-opacity:1;background-color:#15803d;background-color:rgba(21,128,61,var(--bg-opacity));--border-opacity:1;border-color:#15803d;border-color:rgba(21,128,61,var(--border-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
